import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Layout from "../Components/Layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Formik, Form as FormikForm, Field } from "formik";
import * as Yup from "yup";
import { addEditEmergencyNumber, getEmergencyNumberData } from "../Redux/Actions/adminAction";

export default function EmergencyDetail() {
  const dispatch = useDispatch();
  const { emergencyNumber, loading, error } = useSelector(
    (state) => state.usermgmtData 
  );

  useEffect(() => {
    dispatch(getEmergencyNumberData());
  }, [dispatch]);

  const validationSchema = Yup.object().shape({
    number: Yup.string()
      .matches(/^\d{10}$/, "Phone number must be exactly 10 digits")
      .required("Phone number is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      await dispatch(addEditEmergencyNumber({ number: values.number }));
      toast.success("Emergency number updated successfully");
      dispatch(getEmergencyNumberData());
    } catch (error) {
      toast.error("Failed to update emergency number");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout>
      <div className="right-top">
        <div className="heading-top">
          <h2>Emergency Number</h2>
        </div>
        <hr />
      </div>

      <Container fluid>
        <Row className="justify-content-center">
          <Col lg={6}>
            <div className="customer-form-new mt-3">
           
              <hr className="cmn-border" />
              <div className="customer-form-inner">
                {loading ? (
                  <p className="text-center">Loading...</p>
                ) : error ? (
                  <p className="text-center text-danger">Error: {error}</p>
                ) : (
                  <Formik
                    initialValues={{
                      number: emergencyNumber?.number || "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize // Ensure form updates when emergencyNumber changes
                  >
                    {({ errors, touched, isSubmitting }) => (
                      <FormikForm>
                        <Row>
                          <Col lg={12}>
                            <Form.Group className="mb-3">
                              <Form.Label>Emergency Number</Form.Label>
                              <div className="d-flex align-items-center">
                                <span className="me-2">+1</span>
                                <Field
                                  name="number"
                                  type="text"
                                  className={`form-control ${
                                    touched.number && errors.number ? "is-invalid" : ""
                                  }`}
                                  placeholder="Enter 10-digit phone number"
                                />
                              </div>
                              {touched.number && errors.number && (
                                <div className="invalid-feedback">{errors.number}</div>
                              )}
                            </Form.Group>
                          </Col>
                          <Col lg={12} className="d-flex justify-content-center mt-3">
                            <Button
                              type="submit"
                              className="add-btn"
                              disabled={isSubmitting || loading}
                            >
                              {isSubmitting || loading ? "Saving..." : "Save"}
                            </Button>
                          </Col>
                        </Row>
                      </FormikForm>
                    )}
                  </Formik>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
}